/**
 * İstasyon logosunun nereden geldiği. Uygulamanın gösterdiği logoların bir kısmı
 * rakip uygulamaların ya da radyo dizinlerinin sunucularında (radio-browser'a
 * biri öyle eklemiş): onların bant genişliği, her gösterimde kullanıcının IP'si
 * onlara gider, dosya adı değişince kırılır. Bunlar ayıklanıp istasyonun kendi
 * logosuyla değiştirilecek. Sunucu (SQL filtresi) ve konsol aynı listeyi kullanır.
 */
/** Rakip/dizin sunucuları ve kaynağı belirsiz ödünç görseller (alan adı + alt alanları). */
export const RIVAL_LOGO_HOSTS = [
    { name: "TuneIn", hosts: ["tunein.com", "radiotime.com"] },
    { name: "iHeart", hosts: ["iheart.com"] },
    { name: "radio.net", hosts: ["radio.net", "radio.de", "radio.fr", "radio.at", "radio.it", "radio.es", "radio.pt", "radio-assets.com"] },
    { name: "myTuner", hosts: ["mytuner.mobi", "mytuner-radio.com", "app-mind.com"] },
    { name: "OnlineRadioBox", hosts: ["onlineradiobox.com"] },
    { name: "Streema", hosts: ["streema.com"] },
    { name: "Radio Garden", hosts: ["radio.garden"] },
    { name: "Live24", hosts: ["live24.gr"] },
    { name: "Qingting", hosts: ["qtfm.cn", "qingting.fm"] },
    { name: "canliradyodinle", hosts: ["canliradyodinle.fm"] },
    {
        name: "radyo dizini",
        hosts: [
            "radiosindia.com",
            "onlineradiohub.com",
            "radios.com.br",
            "radioarg.net",
            "liveradios.in",
            "top-radio.ru",
            "radioart.com",
            "australiandigitalradio.com",
            "0nradio.com",
        ],
    },
    { name: "Google görsel önizlemesi", hosts: ["gstatic.com"] },
    { name: "Google Play ikonu", hosts: ["play-lh.googleusercontent.com"] },
    { name: "App Store ikonu", hosts: ["mzstatic.com"] },
];
const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
/** Logo adresinin alan adına uygulanır (SQL'de ~* ile, küçük harfe çevrilmiş ada). */
export const RIVAL_LOGO_HOST_PATTERN = `(^|\\.)(${RIVAL_LOGO_HOSTS.flatMap((r) => r.hosts).map(escape).join("|")})$`;
const RIVAL_RE = new RegExp(RIVAL_LOGO_HOST_PATTERN, "i");
/** Adresin alan adı; SQL tarafı aynı ifadeyi kullanır (LOGO_HOST_SQL_RE). */
export const LOGO_HOST_SQL_RE = "^[A-Za-z][A-Za-z0-9+.-]*://(?:[^/?#@]*@)?([^/?#:]+)";
const HOST_RE = /^[A-Za-z][A-Za-z0-9+.-]*:\/\/(?:[^/?#@]*@)?([^/?#:]+)/;
function hostOf(url) {
    const m = url ? HOST_RE.exec(url.trim()) : null;
    return m ? m[1].toLowerCase().replace(/^www\./, "") : null;
}
/** "cdn.radio357.pl" -> "radio357.pl"; "img.bbc.co.uk" -> "bbc.co.uk" (kaba ama yeterli). */
function siteOf(host) {
    const parts = host.split(".");
    const n = parts.length >= 3 && /^(co|com|org|net|gov|edu|ac)$/.test(parts[parts.length - 2]) && parts[parts.length - 1].length === 2 ? 3 : 2;
    return parts.slice(-n).join(".");
}
export function logoOrigin(favicon, homepage) {
    const host = hostOf(favicon);
    if (!host)
        return null;
    if (RIVAL_RE.test(host)) {
        const r = RIVAL_LOGO_HOSTS.find((x) => x.hosts.some((h) => host === h || host.endsWith(`.${h}`)));
        return { kind: "rival", name: r?.name ?? host };
    }
    const home = hostOf(homepage);
    if (home && siteOf(home) === siteOf(host))
        return { kind: "own", name: host };
    if (host.endsWith("wikimedia.org") || host.endsWith("wikipedia.org"))
        return { kind: "wiki", name: host };
    return { kind: "other", name: host };
}
//# sourceMappingURL=logos.js.map